import React, { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import usePageMetadata from '../hooks/usePageMetadata';
import * as authApi from '../api/endpoints/auth';
import { authSection, btnLg, btnPrimary, containerForm, inputClass, labelClass } from '../styles/ui';

const ResetPasswordPage = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const [email, setEmail] = useState(searchParams.get('email') || '');
  const [code, setCode] = useState(searchParams.get('code') || '');
  const [newPassword, setNewPassword] = useState('');
  const [error, setError] = useState(null);
  const [submitting, setSubmitting] = useState(false);

  usePageMetadata({
    title: 'Reset Password | Fresh & Homely',
    description: 'Set a new password for your Fresh & Homely account.',
    canonicalPath: '/reset-password',
  });

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError(null);
    setSubmitting(true);
    try {
      await authApi.resetPassword(email.trim(), code.trim(), newPassword);
      navigate('/login');
    } catch (err) {
      setError(err.message);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <>
      <Navbar />
      <section className={authSection}>
        <div className={`${containerForm} w-full`}>
          <div className="bg-white/90 backdrop-blur-sm rounded-4xl border border-emerald-50 p-8 shadow-floating">
            <h1 className="serif text-3xl text-emerald-950 mb-2 text-center">Reset password</h1>
            <p className="text-ink-secondary text-center mb-8">Enter the code we emailed you and choose a new password.</p>

            <form onSubmit={handleSubmit} className="space-y-4">
              <div>
                <label htmlFor="email" className={labelClass}>Email</label>
                <input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className={inputClass} />
              </div>
              <div>
                <label htmlFor="code" className={labelClass}>Reset code</label>
                <input id="code" required value={code} onChange={(e) => setCode(e.target.value)} className={inputClass} />
              </div>
              <div>
                <label htmlFor="newPassword" className={labelClass}>New password</label>
                <input id="newPassword" type="password" required minLength={8} value={newPassword} onChange={(e) => setNewPassword(e.target.value)} className={inputClass} autoComplete="new-password" />
              </div>

              {error && <p className="text-sm text-red-600">{error}</p>}

              <button
                type="submit"
                disabled={submitting}
                className={`w-full ${btnPrimary} ${btnLg}`}
              >
                {submitting ? 'Resetting...' : 'Reset Password'}
              </button>
            </form>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
};

export default ResetPasswordPage;
